import { CloseIcon } from '../../../assets/icons/Svg'
import { useDispatch, useSelector } from 'react-redux';
import { clearTypeModal, clearTypeOfShowModalType, selectCurrentModalType } from '../../../features/modal/modalSlice';
import { clearSelectedStaff, clearSelectedUser, resetCreateNewStaff } from '../../../features/user/userSlice';

export default function StaffModalHeader() {

    const dispatch = useDispatch()
    const typeModal = useSelector(selectCurrentModalType);

    const handleCloseStaffModal = () => {
        dispatch(clearTypeModal());
        dispatch(clearSelectedUser());
        dispatch(clearTypeOfShowModalType())
        dispatch(clearSelectedStaff())
        dispatch(resetCreateNewStaff())
    }

    return (
        <div className="flex justify-between items-center py-1">
            <div className="items-start">
                <p className="text-sm items-start font-semibold leading-tight text-slate-900">
                    {typeModal === 'newStaff' && 'New Staff'}
                    {typeModal === 'updateStaff' && 'Update Staff'}
                </p>
            </div>
            <div className="flex justify-end items-center">
                <button
                    type="button"
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                    onClick={handleCloseStaffModal}
                >
                    <CloseIcon/>
                </button>
            </div>
        </div>
    )
}
